import React, {Component, Fragment} from 'react';
import {Route, Routes} from 'react-router-dom'
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {withTranslation} from "react-i18next";
import {route} from "../../routes";
import IndustriesLandingController from "./controllers/IndustriesLandingController";
import IndustriesDetailController from "./controllers/IndustriesDetailController";
import {GelContentContainer, NotFound} from "cw-styleguide-react";

class Industries extends Component {
  render() {

    return (
      <Fragment>

        <BreadcrumbsItem to={route('industries')}>
          {this.props.t('industry_title')}
        </BreadcrumbsItem>
        <Routes>
          <Route index exact element={<IndustriesLandingController  jobs={this.props.jobs}/>}/>
          <Route path={route('industry')} element={<IndustriesDetailController jobs={this.props.jobs} />}/>
            <Route path="*" element={<GelContentContainer><NotFound/></GelContentContainer>}/>
        </Routes>
      </Fragment>
    )
  }
}

export default withTranslation('local')(Industries);
